import './ThumbnailCell.scss';
import React, { useState, useEffect, useContext } from 'react';
import { I18nReactContext } from "../../../../../contexts/I18nContext";
import { getCompanyFileDownloadLinkAPI } from "../../../../../Services/api";
import ImageIcon from '@mui/icons-material/Image';
import VideocamIcon from '@mui/icons-material/Videocam';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';

export const ThumbnailCell = ({ fileId, type, signedUrl }) => {
    const { i18n } = useContext(I18nReactContext);
    const [thumbnailUrl, setThumbnailUrl] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    useEffect(() => {
        // If signedUrl is provided, use it directly
        if (signedUrl) {
            setThumbnailUrl(signedUrl);
            setLoading(false);
            return;
        }

        // Fallback to API call if signedUrl is not provided (for backward compatibility)
        const fetchThumbnail = async () => {
            if (!fileId) return;

            try {
                setLoading(true);
                const url = await getCompanyFileDownloadLinkAPI({ fileId });
                setThumbnailUrl(url);
                setError(false);
            } catch (err) {
                console.error("Error fetching thumbnail:", err);
                setError(true);
            } finally {
                setLoading(false);
            }
        };

        fetchThumbnail();
    }, [fileId, signedUrl]);

    const renderPlaceholder = () => {
        if (loading) {
            return <div className="placeholder loading">{i18n.translate('superAdmin.assets.loading')}</div>;
        }

        if (error) {
            return <div className="placeholder error">{i18n.translate('superAdmin.assets.thumbnailError')}</div>;
        }

        // Fallback icon based on file type
        const getIcon = () => {
            const typeUpper = type ? type.toUpperCase() : '';
            switch(typeUpper) {
                case 'IMAGE':
                    return <ImageIcon className="fallbackIcon image" />;
                case 'VIDEO':
                    return <VideocamIcon className="fallbackIcon video" />;
                default:
                    return <InsertDriveFileIcon className="fallbackIcon file" />;
            }
        };

        return <div className="placeholder">{getIcon()}</div>;
    };

    return (
        <div className="ThumbnailCell">
            {thumbnailUrl && (type.toUpperCase() === 'IMAGE' || type.toUpperCase() === 'VIDEO') ? (
                <div className="thumbnailContainer">
                    {type.toUpperCase() === 'IMAGE' ? (
                        <img 
                            src={thumbnailUrl} 
                            alt={i18n.translate('superAdmin.assets.thumbnail')} 
                            className="thumbnail"
                        />
                    ) : (
                        <div className="videoThumbnail">
                            <VideocamIcon className="videoIcon" />
                            <div className="playButton" onClick={() => window.open(thumbnailUrl, '_blank')} />
                        </div>
                    )}
                </div>
            ) : renderPlaceholder()}
        </div>
    );
};
